module.exports = __webpack_public_path__ + "img/storedetails.5808092.jpg";